import React, { Component } from "react";
import { injectIntl, InjectedIntlProps } from "@ai360/core/intl";
import { service, actions } from "./data";
import { preventBubbleUp } from "~/admin/utils";
import { withMasked, withNewApiResult, withValidateImportResults, withCrud } from "~/hocs";
// Components
import AddEditPanel from "./add-edit/add-edit-container";
import { ImportExportHeader } from "../components/import-export-header";
import { DataTable, DialogBox, Button } from "~/core";
import SlidingPanel from "~/sliding-panel/sliding-panel";
import { CropLog } from "./crop-log";
import { messages } from "../i18n-messages";
import { IAgBytesProps, IAgBytesState } from "../interfaces";
import { IDataTableFooterOptions } from "~/core/components/tables/interfaces";

export class Crop_ extends Component<
    IAgBytesProps<typeof actions, typeof AddEditPanel> & InjectedIntlProps,
    IAgBytesState
> {
    tableFooterOptions: Array<IDataTableFooterOptions>;

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.tableFooterOptions = [
            {
                label: "Delete Selected",
                action: this.props.deleteSelected,
            },
        ];
    }
    public onToggleModalClick = (): void => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    render(): JSX.Element {
        const { formatMessage } = this.props.intl;
        const { showAddEditPanel } = this.props.addEditPanel;
        let slidingPanelProps = { ...this.props };
        if (showAddEditPanel) {
            slidingPanelProps = {
                ...slidingPanelProps,
                ...this.props.addEditPanel,
            };
        }
        return (
            <div className="content-table-container">
                <ImportExportHeader
                    {...this.props}
                    service={service}
                    onToggleModalClick={this.onToggleModalClick}
                    onToggleActiveClick={service.toggleColumnVisibility}
                />
                <DataTable
                    isEditable
                    isCheckbox
                    service={service}
                    messages={messages}
                    {...this.props}
                    footerOptions={this.tableFooterOptions}
                />
                {!showAddEditPanel ? null : (
                    <form onSubmit={(event) => preventBubbleUp(event)}>
                        <SlidingPanel
                            {...slidingPanelProps}
                            close={this.props.closeSidePanel}
                            component={AddEditPanel}
                            navigateTo={{
                                parentNameCode: "102",
                                childNameCode: "126",
                            }}
                        >
                            <Button type="save" forceSubmit onClick={() => this.props.onSubmit()} />
                            <Button type="cancel" onClick={() => this.props.closeSidePanel()} />
                        </SlidingPanel>
                    </form>
                )}
                <DialogBox
                    className="view-log-dialog-box"
                    isOpen={this.state.isModalOpen}
                    draggable
                    unrestricted
                    onClose={() => this.onToggleModalClick()}
                    title={formatMessage(messages.cropLogHistory)}
                >
                    <CropLog needs={this.props.needs} />
                </DialogBox>
            </div>
        );
    }
}
export const Crop = injectIntl(
    withMasked(
        withNewApiResult(
            withValidateImportResults(withCrud(Crop_, service, actions, true), actions.importData)
        )
    )
);
